<template>
  <vue-element-loading :active="active" :is-full-screen="true" color="#FF5C67">
    <img class="loading-gif" src="@/assets/images/loading.gif" alt="">
  </vue-element-loading>
</template>
<script>
import VueElementLoading from "vue-element-loading";
export default {
  name: 'page-loading',
  props: ['active'],
  components: {
    VueElementLoading
  }
}
</script>
<style lang="less">
  .loading-gif {
    width: 350px;
  }
</style>